import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from 'axios'
import VueAxios from 'vue-axios'
import autotrack from './assets/js/autotrack.js'
import trackFn from './assets/js/trackFn'
import wx from 'weixin-js-sdk'
//复制到剪切板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// const MyAxios = axios.create({

//   // headers: {
//   //   'Content-Type': 'application/json;charset=UTF-8',
//   //   'deviceVersion':'1.0.0',
//   //   'deviceClientType':'ios',
//   //   'Access-Control-Allow-Origin':'*',
//   //   'Access-Control-Allow-Headers':'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild',
//   //   'Access-Control-Allow-Methods':'*',
//   //   'Access-Control-Allow-Credentials':'true',
//   //   'Access-Control-Expose-Headers':'*'
//   // }
// })

Vue.use(VueAxios, axios)
autotrack.autoTfn();



//利用router方法beforeEach
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

function setRem() {
  //监听窗口变化
  var html = document.querySelector('html');
  var homeWith = window.innerWidth;
  if (homeWith > 450) {
    homeWith = 450;
  }
  html.style.fontSize = homeWith * 100 / 375 + 'px';

  // var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  // var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  // var width = w > h ? h : w;
  // width = width > 450 ? 450 : width
  // var fz = ~~(width*100/375)/1
  // document.getElementsByTagName("html")[0].style.cssText = 'font-size: ' + fz +"px";
  // var realfz = ~~(+window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.replace('px','')*10000)/10000
  // if (fz !== realfz) {
  //     document.getElementsByTagName("html")[0].style.cssText = 'font-size: ' + fz * (fz / realfz) +"px";
  // }
}
setRem()

window.addEventListener('resize', function () {
  console.log(document.body.offsetWidth)
  setRem()
})

//
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
console.log('5')
if (getQueryString('channel')) {
  window['channel'] = getQueryString('channel')
  console.log('channel =', window['channel'])
}
console.log('6')
window['type'] = getQueryString('type')
console.log(window['type'])
if (window['type'] == 'dev') {
  window['domain'] = 'https://uniondrugapp-backend.turboradio.cn'
  window['domainNew'] = 'https://pm-app-jkb.turboradio.cn'
} else if (window['type'] == 'rc') {
  window['domain'] = 'https://uniondrugapp-backend.uniondrug.net'
  window['domainNew'] = 'https://pm-app-jkb.uniondrug.net'
} else {
  window['domain'] = 'https://uniondrugapp-backend.uniondrug.cn'
  window['domainNew'] = 'https://pm-app-jkb.uniondrug.cn'
}

// console.log('window.location.domain=')
// console.log(window.location.host)
// config配置
window.udwxconfig = function (callback) {
  window['openConfig'] = false
  window['configUrl'] = 'https://wxapi.uniondrug.cn/v/wx/config'
  if (window.location.host == 'wx.turboradio.cn') {
    window['configUrl'] = 'https://wxapi.turboradio.cn/v/wx/config'
    window['openConfig'] = true
  }
  else if (window.location.host == 'wx.uniondrug.net') {
    window['configUrl'] = 'https://wxapi.uniondrug.net/v/wx/config'
    window['openConfig'] = true
  }
  else if (window.location.host == 'wx.uniondrug.cn') {
    window['configUrl'] = 'https://wxapi.uniondrug.cn/v/wx/config'
    window['openConfig'] = true
  }

  if (window['openConfig']) {
    Vue.axios
      .post(window['configUrl'], {
        url: window.location.href.split("#")[0]
      })
      .then((response) => {
        console.log('=======')
        console.log(response)
        if (response.data.errno == '0') {
          wx.config({
            debug: false,
            appId: response.data.data.appId,
            timestamp: response.data.data.timestamp,
            nonceStr: response.data.data.nonceStr,
            signature: response.data.data.signature,
            jsApiList: response.data.data.jsApiList,
            openTagList: ['wx-open-launch-app']
          });
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['wx-open-launch-app'],
              success: function () {
                callback()
              },
              fail: () => {

              }
            });
            callback()
          });
        }
      });
  }
}


Vue.config.productionTip = false;

Vue.prototype.$trackFn = trackFn;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
